import React from 'react'
import styled from 'styled-components'
import ResultUpIcon from '../../images/icon-arrow-up-green.svg'
import ResultDownIcon from '../../images/icon-arrow-down-red.svg'
import Result0Icon from '../../images/icon-arrow-up-gray.svg'
import RatingUpIcon from '../../images/icon-heart-green.svg'
import RatingDownIcon from '../../images/icon-heart-red.svg'
import Rating0Icon from '../../images/icon-heart-gray.svg'
import { isNullOrUndefined } from '../../utilities/helpers'

const ProgressIndicator = ({
  resultProgress,
  ratingProgress,
  showResult = true,
  showRating = true,
  size = "md",
  vertical = false
}) => {
  return (
    <Wrapper className={`progress-indicator size-${size} ${vertical ? 'vertical' : ''}`}>
      {showResult &&
        <ResultIndicator className={"result-indicator"}>
          <div className="icon">
            {resultProgress && resultProgress > 0 ? <img src={ResultUpIcon} alt=""/> : null}
            {resultProgress && resultProgress < 0 ? <img src={ResultDownIcon} alt=""/> : null}
            {resultProgress === 0 ? <img src={Result0Icon} alt=""/> : null}
            {isNullOrUndefined(resultProgress) ? <NoResultIcon></NoResultIcon> : null}
          </div>
          {resultProgress > 0 ? "+" : ""}{resultProgress && resultProgress !== 0 ? resultProgress.toFixed(1) + "%" : resultProgress === 0 ? "0" : ""}
        </ResultIndicator>
      }
      {showRating &&
        <RatingIndicator className={"rating-indicator"}>
          <div className="icon">
            {ratingProgress && ratingProgress > 0 ? <img src={RatingUpIcon} alt=""/> : null}
            {ratingProgress && ratingProgress < 0 ? <img src={RatingDownIcon} alt=""/> : null}
            {ratingProgress === 0 ? <img src={Rating0Icon} alt=""/> : null}
            {isNullOrUndefined(ratingProgress) ? <NoResultIcon></NoResultIcon> : null}
          </div>
          {ratingProgress > 0 ? "+" : ""}{ratingProgress && ratingProgress !==0 ? ratingProgress.toFixed(1) : ratingProgress === 0 ? "0" : ""}
        </RatingIndicator>
      }
    </Wrapper>
  )
}

export default ProgressIndicator;

const Wrapper = styled.div`
  font-weight: 500;
  line-height: 1.1;
  display: flex;
  align-items: center;
  
  .rating-indicator {
    margin-left: 10px;
  }
  
  .icon {
    display: flex;
    align-items: center;
    justify-content: center;
    
    img {
      display: block;
      width: 100%;
      height: auto;
    }
  }
  
  &.vertical {
    flex-direction: column;
    align-items: flex-start;
    
    .rating-indicator {
      margin-left: 0;
    }
  }
`;

const ResultIndicator = styled.div`
  display: flex;
  align-items: center;
  
  .size-lg & {
    font-size: 26px;
    
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
  
  .size-md & {
    font-size: 19px;
    
    .icon {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
  
  .size-sm & {
    font-size: 16px;
    
    .icon {
      width: 13px;
      height: 13px;
      margin-right: 4px;
    }
  }
`;

const RatingIndicator = styled.div`
  display: flex;
  align-items: center;
  
  .size-lg & {
    font-size: 26px;
    
    .icon {
      width: 20px;
      height: 20px;
      margin-right: 6px;
    }
  }
  
  .size-md & {
    font-size: 19px;
    
    .icon {
      width: 14px;
      height: 14px;
      margin-right: 5px;
    }
  }
  
  .size-sm & {
    font-size: 15px;
    
    .icon {
      width: 13px;
      height: 13px;
      margin-right: 4px;
      
      img {
        max-width: 12px;
      }
    }
  }
  
  .vertical.size-md & {
    font-size: 16px;
    margin-top: 5px;
  }
`;

const NoResultIcon = styled.div`
  display: block;
  width: 12px;
  height: 3px;
  background-color: #D1D1D1;
`;


// WEBPACK FOOTER //
// ./src/components/progress-reports/progress-indicator.js